import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

function AdminInstallments() {

  const token = localStorage.getItem("access");
  const { t } = useTranslation();

  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");

  const [loading, setLoading] = useState(false);

  const [schoolName, setSchoolName] = useState("");
  const [schoolLogo, setSchoolLogo] = useState("");
  const [academicYear, setAcademicYear] = useState("");
  const [className, setClassName] = useState("");

  const [students, setStudents] = useState([]);

  const [registrationCompleted, setRegistrationCompleted] = useState(0);
  const [firstCompleted, setFirstCompleted] = useState(0);
  const [secondCompleted, setSecondCompleted] = useState(0);
  const [thirdCompleted, setThirdCompleted] = useState(0);

  const [search, setSearch] = useState("");

  useEffect(() => {

    fetchClasses();

  }, []);

  const fetchClasses = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/academics/classes/",
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      setClasses(res.data);

    } catch(err){

      console.error(err);

    }
  };

  const loadInstallments = async (classId) => {

    try {

      setLoading(true);

      const res = await axios.get(
        `https://api.eduskot.com/api/students/installments/${classId}/`,
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      setSchoolName(res.data.school_name);
      setSchoolLogo(res.data.school_logo);
      setAcademicYear(res.data.academic_year);
      setClassName(res.data.class_name);

      setStudents(res.data.students);

      setRegistrationCompleted(
        res.data.registration_completed
      );

      setFirstCompleted(
        res.data.first_installment_completed
      );

      setSecondCompleted(
        res.data.second_installment_completed
      );

      setThirdCompleted(
        res.data.third_installment_completed
      );

    } catch(err){

      console.error(err);

    } finally {

      setLoading(false);

    }
  };

  const handleClassChange = (e) => {

    const value = e.target.value;

    setSelectedClass(value);

    if(value){

      loadInstallments(value);

    }
  };

  const printDefaulters = (
    title,
    filterFn,
    balanceField
  ) => {

    const defaulters =
      students.filter(filterFn);

    const win = window.open(
      "",
      "",
      "width=1200,height=900"
    );

    win.document.write(`
      <html>
      <head>
      <title>${title}</title>

      <style>

      body{
        font-family:Arial;
        padding:30px;
      }

      table{
        width:100%;
        border-collapse:collapse;
      }

      th,td{
        border:1px solid #ddd;
        padding:10px;
        text-align:left;
      }

      th{
        background:#0b4ea2;
        color:white;
      }

      .header{
        text-align:center;
        margin-bottom:20px;
      }

      img{
        width:80px;
        height:80px;
        object-fit:contain;
      }

      </style>

      </head>

      <body>

      <div class="header">

      ${
        schoolLogo
        ?
        `<img src="${schoolLogo}" />`
        :
        ""
      }

      <h2>${schoolName}</h2>

      <h3>${title}</h3>

      <p>
      Academic Year:
      ${academicYear}
      </p>

      <p>
      Class:
      ${className}
      </p>

      </div>

      <table>

      <thead>

      <tr>

      <th>No</th>
      <th>Student</th>
      <th>Admission No</th>
      <th>Amount Paid</th>
      <th>Amount Owing</th>

      </tr>

      </thead>

      <tbody>

      ${defaulters.map((s,index)=>`

      <tr>

      <td>${index+1}</td>

      <td>${s.full_name}</td>

      <td>${s.admission_number}</td>

      <td>${s.total_paid}</td>

      <td>${s[balanceField]}</td>

      </tr>

      `).join("")}

      </tbody>

      </table>

      <br/>

      <h3>
      Total Defaulters:
      ${defaulters.length}
      </h3>

      </body>
      </html>
    `);

    win.document.close();

    win.print();
  };

  const printCompleted = (
  title,
  filterFn
) => {

  const completed =
    students.filter(filterFn);

  const win = window.open(
    "",
    "",
    "width=1200,height=900"
  );

  win.document.write(`
    <html>
    <head>
      <title>${title}</title>

      <style>

        body{
          font-family:Arial;
          padding:30px;
        }

        table{
          width:100%;
          border-collapse:collapse;
        }

        th,td{
          border:1px solid #ddd;
          padding:10px;
          text-align:left;
        }

        th{
          background:#0b4ea2;
          color:white;
        }

        .header{
          text-align:center;
          margin-bottom:20px;
        }

        img{
          width:80px;
          height:80px;
          object-fit:contain;
        }

      </style>

    </head>

    <body>

      <div class="header">

        ${
          schoolLogo
          ?
          `<img src="${schoolLogo}" />`
          :
          ""
        }

        <h2>${schoolName}</h2>

        <h3>${title}</h3>

        <p>
          Academic Year:
          ${academicYear}
        </p>

        <p>
          Class:
          ${className}
        </p>

      </div>

      <table>

        <thead>

          <tr>

            <th>No</th>
            <th>Student</th>
            <th>Admission No</th>
            <th>Amount Paid</th>

          </tr>

        </thead>

        <tbody>

          ${completed.map((s,index)=>`

            <tr>

              <td>${index+1}</td>

              <td>${s.full_name}</td>

              <td>${s.admission_number}</td>

              <td>${s.total_paid}</td>

            </tr>

          `).join("")}

        </tbody>

      </table>

      <br/>

      <h3>
        Total Completed:
        ${completed.length}
      </h3>

    </body>

    </html>
  `);

  win.document.close();

  win.print();
};

  const filteredStudents =
    students.filter((student)=>

      student.full_name
      .toLowerCase()
      .includes(
        search.toLowerCase()
      )

    );

  return (

    <div style={styles.page}>

      <div style={styles.header}>

        <h1>
          {t("installmentManagement")}
        </h1>

        <button
          style={styles.backBtn}
          onClick={() =>
            window.location.href =
            "/admin-dashboard"
          }
        >
          {t("back")}
        </button>

      </div>

<div style={styles.card}>

  <div style={styles.selectorHeader}>
    📚 {t("selectClass")}
  </div>

  <select
    value={selectedClass}
    onChange={handleClassChange}
    style={styles.select}
  >

          <option value="">
            {t("selectClass")}
          </option>

          {classes.map((c)=>(

            <option key={c.id} value={c.id}>
    {c["department__name"]
        ? `${c.name} (${c["department__name"]})`
        : c.name}
</option>

          ))}

        </select>

      </div>

      {className && (

        <>

        <div style={styles.summaryGrid}>

          <div style={styles.summaryCard}>
            {t("registration")}
            <h2>
              {registrationCompleted}
            </h2>
          </div>

          <div style={styles.summaryCard}>
            {t("firstInstallment")}
            <h2>
              {firstCompleted}
            </h2>
          </div>

          <div style={styles.summaryCard}>
            {t("secondInstallment")}
            <h2>
              {secondCompleted}
            </h2>
          </div>

          <div style={styles.summaryCard}>
            {t("thirdInstallment")}
            <h2>
              {thirdCompleted}
            </h2>
          </div>

        </div>

        <div style={styles.printGrid}>

  {/* REGISTRATION */}

  <div style={styles.printColumn}>

    <button
      style={styles.printBtn}
      onClick={()=>
        printDefaulters(
          t("registrationDefaulters"),
          (s)=>
            !s.registration_paid,
          "registration_balance"
        )
      }
    >
      {t("printRegistrationDefaulters")}
    </button>

    <button
      style={styles.completedBtn}
      onClick={()=>
        printCompleted(
          t("registeredStudents"),
          (s)=>
            s.registration_paid
        )
      }
    >
      {t("printRegisteredStudents")}
    </button>

  </div>


  {/* 1ST INSTALLMENT */}

  <div style={styles.printColumn}>

    <button
      style={styles.printBtn}
      onClick={()=>
        printDefaulters(
          t("firstInstallmentDefaulters"),
          (s)=>
            !s.first_installment_paid,
          "first_installment_balance"
        )
      }
    >
      {t("printFirstInstallmentDefaulters")}
    </button>

    <button
      style={styles.completedBtn}
      onClick={()=>
        printCompleted(
          t("completedFirstInstallment"),
          (s)=>
            s.first_installment_paid
        )
      }
    >
      {t("printCompletedFirstInstallment")}
    </button>

  </div>


  {/* 2ND INSTALLMENT */}

  <div style={styles.printColumn}>

    <button
      style={styles.printBtn}
      onClick={()=>
        printDefaulters(
          t("secondInstallmentDefaulters"),
          (s)=>
            !s.second_installment_paid,
          "second_installment_balance"
        )
      }
    >
      {t("printSecondInstallmentDefaulters")}
    </button>

    <button
      style={styles.completedBtn}
      onClick={()=>
        printCompleted(
          t("completedSecondInstallment"),
          (s)=>
            s.second_installment_paid
        )
      }
    >
      {t("printCompletedSecondInstallment")}
    </button>

  </div>


  {/* 3RD INSTALLMENT */}

  <div style={styles.printColumn}>

    <button
      style={styles.printBtn}
      onClick={()=>
        printDefaulters(
          t("thirdInstallmentDefaulters"),
          (s)=>
            !s.third_installment_paid,
          "third_installment_balance"
        )
      }
    >
      {t("printThirdInstallmentDefaulters")}
    </button>

    <button
      style={styles.completedBtn}
      onClick={()=>
        printCompleted(
          t("completedThirdInstallment"),
          (s)=>
            s.third_installment_paid
        )
      }
    >
      {t("printCompletedThirdInstallment")}
    </button>

  </div>

</div>

        <input
          type="text"
          placeholder={t("searchStudent")}
          value={search}
          onChange={(e)=>
            setSearch(e.target.value)
          }
          style={styles.search}
        />

        <div style={styles.tableCard}>

          <table style={styles.table}>

            <thead>

              <tr>

                <th style={styles.th}>
                  {t("fullName")}
                </th>

                <th style={styles.th}>
                  {t("admissionNo")}
                </th>

                <th style={styles.th}>
                  {t("registration")}
                </th>

                <th style={styles.th}>
                  {t("firstInstallment")}
                </th>

                <th style={styles.th}>
                  {t("secondInstallment")}
                </th>

                <th style={styles.th}>
                  {t("thirdInstallment")}
                </th>

                <th style={styles.th}>
                  {t("amountPaid")}
                </th>

                <th style={styles.th}>
                  {t("balance")}
                </th>

              </tr>

            </thead>
            <tbody>

              {filteredStudents.map((s)=>(

                <tr key={s.id}>

                  <td style={styles.td}>
                    {s.full_name}
                  </td>

                  <td style={styles.td}>
                    {s.admission_number}
                  </td>

                  <td style={styles.td}>
                    {s.registration_paid
                    ? "✅"
                    : "❌"}
                  </td>

                  <td style={styles.td}>
                    {s.first_installment_paid
                    ? "✅"
                    : "❌"}
                  </td>

                  <td style={styles.td}>
                    {s.second_installment_paid
                    ? "✅"
                    : "❌"}
                  </td>

                  <td style={styles.td}>
                    {s.third_installment_paid
                    ? "✅"
                    : "❌"}
                  </td>

                  <td style={styles.td}>
                    {s.total_paid}
                  </td>

                  <td style={styles.td}>
                    {s.balance}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

        </>

      )}

      {loading && (

        <h3>
          Loading...
        </h3>

      )}

    </div>
  );
}

const styles = {

  page:{
    padding:"7px",
    background:"#f8fafc",
    minHeight:"100vh"
  },

  header:{
    display:"flex",
    justifyContent:"space-between",
    marginBottom:"20px"
  },

card:{
  background:"white",
  padding:"24px",
  borderRadius:"18px",
  marginBottom:"25px",
  boxShadow:"0 10px 30px rgba(0,0,0,0.06)"
},

select:{
  width:"100%",
  padding:"16px 18px",
  borderRadius:"14px",
  border:"2px solid #dbeafe",
  background:"#f8fafc",
  fontSize:"16px",
  fontWeight:"600",
  color:"#0f172a",
  cursor:"pointer",
  outline:"none"
},

  summaryGrid:{
    display:"grid",
    gridTemplateColumns:
    "repeat(auto-fit,minmax(200px,1fr))",
    gap:"20px",
    marginBottom:"20px"
  },

  summaryCard:{
    background:"white",
    padding:"20px",
    borderRadius:"12px",
    textAlign:"center"
  },

  printGrid:{
    display:"grid",
    gridTemplateColumns:
    "repeat(auto-fit,minmax(250px,1fr))",
    gap:"15px",
    marginBottom:"20px"
  },

  printBtn:{
    padding:"14px",
    border:"none",
    borderRadius:"10px",
    background:"#eb0c1f",
    color:"white",
    cursor:"pointer"
  },

  printColumn:{
  display:"flex",
  flexDirection:"column",
  gap:"8px"
},

completedBtn:{
  padding:"12px",
  border:"none",
  borderRadius:"10px",
  background:"#198754",
  color:"white",
  cursor:"pointer"
},

  search:{
    width:"100%",
    padding:"12px",
    marginBottom:"20px"
  },

  tableCard:{
    background:"white",
    borderRadius:"12px",
    overflow:"auto"
  },

  selectorHeader:{
  marginBottom:"12px",
  fontSize:"15px",
  fontWeight:"700",
  color:"#2563eb"
},

  table:{
    width:"100%",
    borderCollapse:"collapse",
    tableLayout:"fixed"
    },

    th:{
  padding:"14px",
  textAlign:"center",
  background:"#f1f5f9",
  borderBottom:"2px solid #e2e8f0",
  fontWeight:"700"
},

td:{
  padding:"14px",
  textAlign:"center",
  borderBottom:"1px solid #e2e8f0"
},

backBtn:{
  padding:"12px",
  background:"#2563eb",
  color:"white",
  border:"none",
  borderRadius:"10px",
  fontWeight:"600",
  cursor:"pointer",
  width:"65px",
  height:"40px"

}
};

export default AdminInstallments;